module.exports = require('../node_modules/moment-timezone/moment-timezone');
module.exports.tz.load(require('!json-loader!val-loader!./moment-timezone-builder'));
